'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var uuid = _interopDefault(require('uuid/v4'));
var moment = _interopDefault(require('moment'));
var collection = require('lodash/collection');
var lang = require('lodash/lang');

var EVENT_CONSTANTS = {
	METHOD: {
		STARTED: 'started',
		CLOSED: 'closed',
		ACTIVATED: 'activated',
		DEACTIVATED: 'deactivated',
		APPEARED: 'appeared',
		DISAPPEARED: 'disappeared',
		INTERACTED: 'interacted',
		CRASHED: 'crashed',
		CTA: 'cta'
	},
	EXPERIENCE: {
		VIEW: '/user/experience/view',
		ACTIVITY: '/user/experience/activity',
		LIFECYCLE: '/user/experience/lifecycle'
	},
	BEHAVIOUR: {
		POSITIVE: 'POSITIVE-ACCEPTED',
		NEGATIVE: 'NEGATIVE-DECLINED',
		NEUTRAL: 'NEUTRAL-REMINDLATER'
	},
	CONTEXT: {
		BENEFICIARY_CREATE: 'beneficiary_create',
		BENEFICIARY_UPDATE: 'beneficiary_update'
	}
};
var CHANNEL_ID = 'WEB';
var SEND_INTERVAL = 20000;

var getScreenSize = function getScreenSize() {
	var docEle = document.documentElement;
	var body = document.getElementsByTagName('body');
	var x = window.innerWidth || docEle.clientWidth || body[0].clientWidth;
	var y = window.innerHeight || docEle.clientHeight || body[0].clientHeight;
	return { x: x, y: y };
};

var getURLPathName = function getURLPathName() {
	return window.location.pathname;
};

var getCommonAttributes = function getCommonAttributes() {
	return {
		userAgent: navigator.userAgent || navigator.vendor || window.opera,
		channelID: CHANNEL_ID,
		url: window.location.href
	};
};

var getCommonMetrics = function getCommonMetrics() {
	var screenSize = getScreenSize();
	return {
		screenWidth: screenSize.x || undefined,
		screenHeight: screenSize.y || undefined
	};
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var getAttributeArray = function getAttributeArray(objectData) {
	if (lang.isString(objectData)) {
		return [{ description: objectData }];
	}
	return collection.map(objectData, function (value, key) {
		var obj = {};
		obj[key] = String(value);
		return obj;
	});
};

var getUserEventsPayload = function getUserEventsPayload(_ref) {
	var path = _ref.path,
	    action = _ref.action,
	    context = _ref.context,
	    attribute = _ref.attribute,
	    _ref$metrics = _ref.metrics,
	    metrics = _ref$metrics === undefined ? {} : _ref$metrics;
	return {
		id: uuid(),
		created_at: moment().toISOString(),
		type: {
			path: path,
			action: action
		},
		data: {
			context: context || getURLPathName(),
			attributes: {
				attribute: getAttributeArray(_extends({}, getCommonAttributes(), attribute))
			},
			metrics: {
				attribute: getAttributeArray(_extends({}, getCommonMetrics(), metrics))
			}
		}
	};
};

var eventPayloadList = [];

var getPayloadList = function getPayloadList() {
	var payload = [].concat(toConsumableArray(eventPayloadList));
	eventPayloadList = [];
	return payload;
};

var UserEvents = {
	generateActivityEvents: function generateActivityEvents(action, attribute, metrics, context) {
		var payload = getUserEventsPayload({
			path: EVENT_CONSTANTS.EXPERIENCE.ACTIVITY,
			action: action,
			context: context,
			attribute: attribute,
			metrics: metrics
		});
		eventPayloadList.push(payload);
	},
	generateViewEvents: function generateViewEvents(action, attribute, metrics, context) {
		var payload = getUserEventsPayload({
			path: EVENT_CONSTANTS.EXPERIENCE.VIEW,
			action: action,
			context: context,
			attribute: attribute,
			metrics: metrics
		});
		eventPayloadList.push(payload);
	},
	generateLifecycleEvents: function generateLifecycleEvents(action, attribute, metrics, context) {
		var payload = getUserEventsPayload({
			path: EVENT_CONSTANTS.EXPERIENCE.LIFECYCLE,
			action: action,
			context: context,
			attribute: attribute,
			metrics: metrics
		});
		eventPayloadList.push(payload);
	},
	generateEvents: function generateEvents(path, action, attribute, metrics, context) {
		var payload = getUserEventsPayload({
			path: path,
			action: action,
			context: context,
			attribute: attribute,
			metrics: metrics
		});
		eventPayloadList.push(payload);
	}
};

var callUserEventsService = function callUserEventsService() {
	var payloadList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var request = arguments[1];
	var apiUrl = request.apiUrl,
	    bankId = request.bankId,
	    headers = request.headers;

	if (payloadList.length > 0) {
		fetch(apiUrl + '/banks/' + bankId + '/user/events', {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(payloadList)
		});
	}
};
var beneficiaryUserEventService = function beneficiaryUserEventService(payload, request, errorCallback) {
	var apiUrl = request.apiUrl,
	    bankId = request.bankId,
	    headers = request.headers;

	fetch(apiUrl + '/ibapi/v2/banks/' + bankId + '/user/events/beneficiary', {
		method: 'POST',
		headers: headers,
		body: JSON.stringify(payload)
	}).catch(function (error) {
		errorCallback(error);
	});
};

var eventRequest = void 0;
var timerInterval = void 0;
var dispatchTimer = void 0;

var BusinessEvents = {
	initializeBusinessEvents: function initializeBusinessEvents(request, interval) {
		eventRequest = request;
		timerInterval = interval;
		BusinessEvents.scheduleBusinessEvent();
	},
	scheduleBusinessEvent: function scheduleBusinessEvent() {
		if (dispatchTimer === undefined) {
			var timer = timerInterval || SEND_INTERVAL;
			dispatchTimer = setTimeout(BusinessEvents.attemptDispatch, timer);
		}
	},
	stopBusinessEventTimer: function stopBusinessEventTimer() {
		clearTimeout(dispatchTimer);
		dispatchTimer = undefined;
		var payload = getPayloadList();
		callUserEventsService(payload, eventRequest);
	},
	attemptDispatch: function attemptDispatch() {
		BusinessEvents.stopBusinessEventTimer();
		BusinessEvents.scheduleBusinessEvent();
		var payload = getPayloadList();
		callUserEventsService(payload, eventRequest);
	}
};

var INTERACTED = EVENT_CONSTANTS.METHOD.INTERACTED;
var _EVENT_CONSTANTS$CONT = EVENT_CONSTANTS.CONTEXT;
var BENEFICIARY_CREATE = _EVENT_CONSTANTS$CONT.BENEFICIARY_CREATE;
var BENEFICIARY_UPDATE = _EVENT_CONSTANTS$CONT.BENEFICIARY_UPDATE;
var ACTIVITY = EVENT_CONSTANTS.EXPERIENCE.ACTIVITY;


var BeneficiaryEvents = {
	createBeneficiaryEvent: function createBeneficiaryEvent(_ref) {
		var attribute = _ref.attribute,
		    metrics = _ref.metrics,
		    eventRequest = _ref.eventRequest,
		    errorCallback = _ref.errorCallback;

		var payload = getUserEventsPayload({
			path: ACTIVITY,
			action: INTERACTED,
			context: BENEFICIARY_CREATE,
			attribute: attribute,
			metrics: metrics
		});
		beneficiaryUserEventService([payload], eventRequest, errorCallback);
	},
	updateBeneficiaryEvent: function updateBeneficiaryEvent(_ref2) {
		var attribute = _ref2.attribute,
		    metrics = _ref2.metrics,
		    eventRequest = _ref2.eventRequest,
		    errorCallback = _ref2.errorCallback;

		var payload = getUserEventsPayload({
			path: ACTIVITY,
			action: INTERACTED,
			context: BENEFICIARY_UPDATE,
			attribute: attribute,
			metrics: metrics
		});
		beneficiaryUserEventService([payload], eventRequest, errorCallback);
	}
};

exports.BusinessEvents = BusinessEvents;
exports.UserEvents = UserEvents;
exports.BeneficiaryEvents = BeneficiaryEvents;
exports.EVENT_CONSTANTS = EVENT_CONSTANTS;
exports.CHANNEL_ID = CHANNEL_ID;
exports.SEND_INTERVAL = SEND_INTERVAL;
